import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";

export const getNestCoupons = () => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin/nest_coupons?${params}`);
  };
};

export const saveNestCoupon = (coupon) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.post(`/admin/save_nest_coupon?${params}`, coupon);
  };
};
